import { MDBContainer } from "mdbreact";
import styled, { css, keyframes } from "styled-components";

export const ProductAboutButtonGroupContainer = styled(MDBContainer)`
  display: flex;
  flex-wrap: wrap;
  padding: 5% 3% 2% 3%;
`;
